export default __webpack_public_path__ + "static/media/quickshot3.8c5fd8ad.png";